<template>
  <div class="columns is-multiline">

    <custom-sido ref="customSido"
      v-show="false"
      @getData="getData"></custom-sido>

    <div class="column is-full">
      <div class="box">
        <div class="columns">
          <div class="column flex align-center is-4">
            <div class="label" style="margin-bottom:0">검색</div>
            <input class="input"
                   style="margin:0 8px;flex:1;max-width:400px;"
                   :value="input.search"
                   @input="e => availSearch(e.target.value)"
                   placeholder="지역을 검색하는 곳 입니다."
                   type="text">
          </div>
          <div class="column">
            <div class="columns">
              <div class="column flex align-center">
                <lp-check-bool :checkedVal.sync="input.check" label="서비스 가능 지역만 보기"></lp-check-bool>
              </div>
              <div class="column flex" style="justify-content: flex-end">
                <button class="button is-primary" @click="availSearch">검색하기</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column is-full">
      <div class="box">
        <admin-box-item title="Featured 지역 목록">
          <div class="btn-group-justify-end" style="margin-bottom:12px">
            <button class="button is-primary" @click="add()">추가하기</button>
          </div>

          <div style="overflow-x: auto">
            <div style="min-width:700px">
              <div class="flex" style="border-bottom: 2px solid #dbdbdb;">
                <div class="lp-table-td lp-table-head" style="width:20%">Featured 지역명</div>
                <div class="lp-table-td lp-table-head" style="width:20%">매칭된 주소내역</div>
                <div class="lp-table-td lp-table-head" style="width:20%">서비스 파트너 수</div>
                <div class="lp-table-td lp-table-head" style="width:20%">서비스 상품 수</div>
                <div class="lp-table-td lp-table-head" style="width:20%"></div>
              </div>

              <div
                v-for="(list, idx) in searchItems" :key="'feat'+idx"
                v-if="(input.check && list.partner_count>0) || input.check === false">
                <div class="flex" @click="clickItem(list)"
                     :class="{'lp-sel-color':list.selected}"
                     style="border-bottom: 2px solid #dbdbdb;">
                  <!-- 상위지역 -->
                  <div class="lp-table-td" style="width:20%">
                    <div class="flex justify-center align-center">
                      <div v-if="list.name !== '없음'">{{ list.name }}</div>
                      <div>({{ list.items.length }})</div>
                      <div style="height:22px;margin-left:4px">
                        <i class="material-icons">{{ list.selected ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</i>
                      </div>
                    </div>
                  </div>
                  <div class="lp-table-td" style="width:20%"></div>
                  <div class="lp-table-td" style="width:20%">{{ list.partner_count }}</div>
                  <div class="lp-table-td" style="width:20%">{{ list.product_count }}</div>
                  <div class="lp-table-td" style="width:20%">
                    <div>
                      <button class="button half"
                        @click.stop="onClickModifyCustomSidoButton(list.id)">수정</button>
                      <button class="button half is-danger"
                        @click.stop="onClickDeleteCustomSidoButton(list.id)">삭제</button>
                    </div>
                  </div>
                </div>

                <div
                  v-for="(items, fidx) in list.items" :key="'feat'+fidx"
                  v-if="list.items && list.selected">
                  <div class="flex" style="border-bottom: 2px solid #dbdbdb;">
                    <div class="lp-table-td" style="width:20%">{{ items.name }}</div>
                    <div class="lp-table-td" style="width:20%;flex-wrap:wrap">
                      <span
                        v-for="(add, idx) in items.address_list" :key="`add-${idx}`"
                        style="margin-right: 4px">
                        {{ add }}
                        <span v-if="idx < items.address_list.length-1">,</span>
                      </span>
                    </div>
                    <div class="lp-table-td" style="width:20%">{{ items.partner_count }}</div>
                    <div class="lp-table-td" style="width:20%">{{ items.product_count }}</div>
                    <div class="lp-table-td" style="width:20%">
                      <div>
                        <button class="button half"
                          @click="modifyFeaturedItem(items)">수정</button>
                        <button class="button half is-danger"
                          @click="deleteFeaturedItem(items.id)">삭제</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 누락된 서비스 가능 지역 -->
          <div v-if="missingRegion.count > 0">
            <div style="display: flex;align-items: center;margin:8px 0;justify-content: flex-end">
              <i class="material-icons" style="color:#064160">sim_card_alert</i>
              <div style="font-size:0.9rem;color:#999;margin-left:12px;justify-content: flex-end">누락된 서비스 가능 지역이 <span
                style="color:#064160">{{ missingRegion.count }}</span>곳 있습니다!
              </div>
            </div>
            <div
              v-for="region in missingRegion.region" :key="region"
              style="text-align:right;color:#064160;font-size:0.9rem">{{
              region }}
            </div>
          </div>
        </admin-box-item>
      </div>
    </div>
  </div>
</template>

<script>
  import LpModal from '../../module/common/LpModal.vue'
  import LpUpperRegionDropDown from '../../module/common/LpUpperRegionDropDown'
  import LpCheckBool from "../../module/common/LpCheckBool";
  import LpSortDropDown from "../../module/common/LpSortDropDown";
  import LpInputText from "../../module/common/LpInputText";
  import CustomSido from "../../module/custom/CustomSido";

  export default {

    components: {
      LpInputText,
      LpSortDropDown,
      LpCheckBool, LpModal, LpUpperRegionDropDown,
      CustomSido
    },
    computed: {
      upperRegion() {
        let partner = find(this.upper_list, 'value', this.featured.sido);
        if (partner !== undefined)
          return partner.label;
        else
          return '';
      }
    },
    data() {
      return {
        input: {
          search: '',
          check: true,
        },
        // 커스텀 지역
        featured: {
          id: 0,
          sido: '',
          title: '',
          region: []
        },
        label: '',
        // 매핑할 지역이름
        map_region: '',
        // 상위선택지역 선택후 받은 지역의 구군 동
        region_store: [],
        boxes: [],
        tags: [],
        // 상위 지역(시도)
        upper_list: [],
        tableItems: [],
        searchItems: [],
        del_id: 0,
        //누락된 지역
        missingRegion: {
          count: 0,
          region: ['광주광역시 동구 동명동', '광주 동구 금남로5가']
        },
        selectedList: undefined,
        all_count: 0
      }
    },
    created() {
      this.getData();
    },
    methods: {
      // 검색결과, 해당 열 표시 여부
      availSearch(value) {
        this.input.search = value;
        let search_items = [];
        for(let i=0; i<this.tableItems.length; i++){
          if(this.tableItems[i].name.match(value)){
            search_items.push(this.tableItems[i])
          }
        }
        this.searchItems = search_items;
/*
        for (let idx = 0; idx < this.feat_list.length; idx++) {
          let list = this.feat_list[idx];

          let avail = false;
          for (let i = 0; i < list.regions.length; i++) {
            let region = list.regions[i];
            // Featured 지역명 검색
            if (this.input.search !== '' && region.title.search(this.input.search) > -1) {
              avail = true;
              region.visible = true;
            }
            else {
              for (let j = 0; j < region.regions.length; j++) {
                // Featured 지역내 매칭된 주소목록 검색
                if (region.regions[i].fullText.search(this.input.search) > -1) {
                  avail = true;
                  break;
                }
              }
              if (this.input.check) {
                if (region.part_cnt > 0 || region.prod_cnt > 0) {
                  region.visibile = avail;
                } else {
                  region.visible = false;
                }
              }
              else
                region.visible = avail;
            }
          }

          if (avail) {
            list.vRegion = true;
          }
          else
            list.vRegion = false;
        }*/
      },
      clickItem(list) {
        list.selected ? list.selected = false : list.selected = true
      },
      // 박스 지역 선택
      selectBox(box) {
        if (box != undefined) {
          this.map_region = ''
          if (box.sigungu_id) {
            this.featured.region.push({
              sigungu_id: box.sigungu_id,
              full_text: box.full_text
            });
          }
          else if (box.dong_id) {
            this.featured.region.push({
              dong_id: box.dong_id,
              full_text: box.full_text
            });
          }
          this.boxes = [];
        }
      },
      add() {
        this.featured = {
          id: 0,
          sido: '',
          title: '',
          region: []
        };

        let value = {
          featured: this.featured,
          map_region: this.map_region,
          region_store: this.region_store,
          boxes: this.boxes,
          upper_list: this.upper_list
        };
        this.$store.commit('openModal', {type: 'modal-add-featured-region', value: value});
      },
      deleteFeaturedItem(id) {
        let value = {
          id: id,
          url: 'address/featured/item/',
        }
        this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
      },
      modifyFeaturedItem(list) {
        this.selectedList = list;
        //this.$refs.regFeatured.open();
        this.$axios.get('admin/address/featured/item/' + list.id).then(res => {
          if (res.status === 200) {
            this.featured.sido = res.data.featured_sido_id;
            this.featured.title = res.data.name;
            this.featured.id = res.data.id;
            this.featured.region = res.data.address_set;

            this.$axios.get('admin/address/default/sido/' + res.data.featured_sido_id + '/all').then(res => {
              if (res.status === 200) {
                this.region_store = res.data;
              }
            })

            let value = {
              featured: this.featured,
              map_region: this.map_region,
              region_store: this.region_store,
              boxes: this.boxes,
              upper_list: this.upper_list
            };
            this.$store.commit('openModal', {type: 'modal-add-featured-region', value: value})
          }
        })
      },

      onClickModifyCustomSidoButton(id) {
        this.$refs.customSido.modifyCustomSido(id);
      },

      onClickDeleteCustomSidoButton(id) {
        this.$refs.customSido.deleteCustomSido(id);
      },

      sido() {
        return {
          value: this.featured.sido,
          label: find(this.selectOptions, 'value', this.featured.sido).label
        }
      },
      delTag(index) {
        this.featured.region.splice(index, 1)
      },
      getData() {
        // 모든 지역 가져오기
        this.$axios.get('admin/address/featured/all').then(res => {
          if (res.status === 200) {
            this.tableItems = res.data;
            this.searchItems = res.data;

          }
        });
        // 상위지역 가져오기
        this.$axios.get('admin/address/featured/sido').then(res => {
          if (res.status === 200) {
            let sido_list = res.data;
            let sido_list_copy = [];
            for (let i = 0; i < sido_list.length; i++) {
              sido_list_copy.push({
                label: sido_list[i].name,
                value: sido_list[i].id
              })
            }
            this.upper_list = sido_list_copy;
          }
        });
        // 누락된 지역 가져오기
        this.$axios.get('admin/address/featured/missing').then(res => {
          if (res.status === 200) {
            this.missingRegion.region = res.data;
            this.missingRegion.count = res.data.length;
          }
        })
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
  //@import '~assets/css/lp_main'

  .lp-bg-table
    position relative

  .lp-search
  .lp-checkbox
  .lp-select
    margin-left 12px
    align-items center

  .lp-checkbox
    label
      line-height 36px

  .lp-flex
    display flex

  .lp-search-title
    color $primary
    line-height 2.2rem

  .lp-checkbox > div
    line-height 2.2rem

  .lp-right-search
    padding 4px 16px
    border-radius 3px
    border 1px solid $primary
    color $primary
    line-height 1.7rem
    position absolute
    right 20px

  .lp-add
    float right
    padding 10px 18px
    margin-bottom 12px
    background $primary
    color white
    border-radius 3px

  .lp-modal-div
    text-align left
    padding 28px 24px

  .modal-title
    font-size 1.2rem
    padding-bottom 16px
    border-bottom 1px solid #555

  .lp-modal-content-div
    padding 4px 8px

  .lp-modal-bottom
    border-top 1px solid #555
    display flex
    justify-content flex-end
    margin-top 120px

  .lp-modal-bottom div:last-child
  .lp-modal-bottom div:first-child
    padding 8px 40px
    border-radius 3px
    margin-top 12px

  .lp-modal-bottom div:last-child
    background $primary
    color white

  .lp-modal-bottom div:first-child
    background #eee
    color #555
    margin-right 8px

  .modal-name > input
    padding 4px 8px
    width 50%

  .modal-address
    display flex
    flex-wrap wrap
    background #f2f7f8
    padding 4px

  /*.modal-address > input
    width 87%*/

  .modal-title
  .title
    color #092b43
    min-width 110px

  .title-desc
  .title
    margin-bottom 8px
    margin-top 24px

  .title-desc
    font-size .7rem
    color #555

  .sweet-modal
    width 100% !important

  .lp-box
    position absolute
    background white
    z-index 1
    top 30px
    margin-top 8px
    border 1px solid #eee
    border-radius 3px
    padding 12px
    max-height 180px
    overflow-y auto

  .lp-box > div
    cursor pointer

  .lp-box > div:hover
    color $primary

  .modal-tag
    margin-right 4px
    padding 5px 12px 2px 12px
    border 1px solid #eee
    border-radius 4px
    background white

  .modal-tag i
    margin-left 8px
    font-size 0.9rem

  .modal-input-mapping
    margin-top 3px
    width 100%

  .justify-center
    justify-content center

  .lp-modify
  .lp-delete
    padding 8px 16px
    color white
    margin 0 2px
    border-radius 3px

  .lp-modify
    background #e88710

  .lp-delete
    background #bc191c

  .no-border
    border 0

  .lp-sido-span
    background-color $background
    border-radius 3px
    margin-right 8px
    padding 4px 16px

  .table td,
  .table th
    width 20%

  .lp-sel-color
    background-color #f2f7f8

  .lp-table-td
    padding 0.5em 0.75em
    display flex
    justify-content center
    align-items center

  .lp-table-head
    color #363636
    font-weight bold
</style>
